
import React, { useMemo, useState } from "react";
import { Card, Modal, Tag, Button, Space, Typography, Spin, Layout } from "antd";
import {
  FileProtectOutlined,
  FilePdfOutlined,
  EyeOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { Header } from "../components/layout/header";

const { Title, Text } = Typography;

export default function PrivacyPolicy({
    selectedDoctorId,
    setSelectedDoctorId,
    selectedDate,
    setSelectedDate,
    options}) {
  
  const cards = useMemo(
    () => [
     
      {
        key: "agreements",
        title: "Terms of Use",
        tag: "Legal",
        color: "green",
        pdfUrl: "Terms of Use.pdf",
      },
      {
        key: "privacy",
        title: "Privacy Policy",
        tag: "Legal",
        color: "green",
        pdfUrl:
          "Privacy Policy.pdf",
      },
    ],
    []
  );

  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null); 
  const [pdfLoading, setPdfLoading] = useState(false);

  const logout = () => {
    instance.logout();
    sessionStorage.clear();
  };

  const handleOpen = (item) => {
    setActive(item);
    setPdfLoading(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setActive(null);
    setPdfLoading(false);
  };

  return (
    <Layout className="flex flex-col items-center h-screen">
    <Header
      onLogout={logout}
      selectedDoctorId={selectedDoctorId}
      onSelectDoctor={setSelectedDoctorId}
      options={options}
      
    />
    <div className="p-4">
      <div className="mb-4">
        <Title level={4} style={{ margin: 0 }}>
        Terms of Use & Privacy Policy
        </Title>
        <Text type="secondary">
          View the latest policies and agreements. Click a card to preview the PDF.
        </Text>
      </div>

      <div className="flex flex-wrap gap-4">
        {cards?.map((item) => (
          <Card
            key={item.key}
            hoverable
            className="transition-all duration-200 hover:shadow-lg"
            style={{ width: 320 }}
            onClick={() => handleOpen(item)}
            cover={
              <div
                className="flex items-center justify-center"
                style={{ height: 140, background: "rgba(22, 119, 255, 0.05)" }}
              >
                <FilePdfOutlined style={{ fontSize: 48, color: "#1677ff" }} />
              </div>
            }
           
          >
            <Space direction="vertical" size={4} style={{ width: "100%" }}>
              <Space style={{ justifyContent: "space-between", width: "100%" }}>
                <Title level={5} style={{ margin: 0 }}>
                  {item.title}
                </Title>
                <Tag color={item.color}>{item.tag}</Tag>
              </Space>
              <Text type="secondary">{item.subtitle}</Text>
              <Space size={8}>
                <FileProtectOutlined />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  PDF • Click to preview
                </Text>
              </Space>
            </Space>
          </Card>
        ))}
      </div>

      <Modal
        title={
          <Space>
            <FilePdfOutlined />
            <span>{active?.title || "Document"}</span>
          </Space>
        }
        open={open}
        onCancel={handleClose}
        footer={null}
        // footer={
        //   <Space>
        //     <Button onClick={handleClose}>Close</Button>
        //     {active?.pdfUrl && (
        //       <Button
        //         type="primary"
        //         href={active.pdfUrl}
        //         target="_blank"
        //         rel="noopener noreferrer"
        //         icon={<DownloadOutlined />}
        //       >
        //         Download
        //       </Button>
        //     )}
        //   </Space>
        // }
        width={920}
        bodyStyle={{ padding: 0 }}
        destroyOnClose
      >
        <div style={{ position: "relative", minHeight: "80vh" }}>
          {pdfLoading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1,
                background: "rgba(255,255,255,0.6)",
                backdropFilter: "blur(2px)",
              }}
            >
              <Spin tip="Loading PDF..." />
            </div>
          )}

          {active?.pdfUrl ? (
            <iframe
              title="Policy PDF"
              src={active.pdfUrl}
              style={{ width: "100%", height: "80vh", border: "none" }}
              onLoad={() => setPdfLoading(false)}
            />
          ) : (
            <div className="p-6">
              <Text type="danger">No PDF URL provided.</Text>
            </div>
          )}
        </div>
      </Modal>
    </div>
    </Layout>
  );
}
